import no_data_icon from './no_data.svg';
import { vfIconSimpleExtender } from '../icon/icon.js';


/**
 * No Data
 *
 * @data {"attrs": {"class": "vf-icon-large"}}
 * @styleguide components.icons.no_data
 */
export const vfNoDataIcon = vfIconSimpleExtender('no-data', no_data_icon, '5 -5 100 105');
